import React from "react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { SellerPaymentInfo } from "@/types/AppTypes";

interface PaymentMethodDisplayProps {
    paymentInfo: SellerPaymentInfo;
  onUpdateClick: () => void;
}

export const PaymentMethodDisplay = ({ paymentInfo, onUpdateClick }: PaymentMethodDisplayProps) => {
  // Mask the account number for security
  const maskedAccountNumber = `****${paymentInfo?.account_number?.slice(-4)}`;

  return (
    <Card className="bg-white border border-gray-200 shadow-sm">
      <CardHeader className="pb-4">
        <CardTitle className="text-xl font-semibold text-gray-900">Payment Method</CardTitle>
        <CardDescription className="text-gray-500">How you receive your funds</CardDescription>
      </CardHeader>
      <CardContent className="space-y-6">
        <div className="space-y-3">
          <div className="flex justify-between items-center">
            <span className="text-gray-700 font-medium">Method:</span>
            <span className="text-gray-900">Direct Deposit</span>
          </div>
          <div className="flex justify-between items-center">
            <span className="text-gray-700 font-medium">Account Holder:</span>
            <span className="text-gray-900">{paymentInfo?.account_holder_name}</span>
          </div>
          <div className="flex justify-between items-center">
            <span className="text-gray-700 font-medium">Bank:</span>
            <span className="text-gray-900">{paymentInfo?.bank_name}</span>
          </div>
          <div className="flex justify-between items-center">
            <span className="text-gray-700 font-medium">Account:</span>
            <span className="text-gray-900">{maskedAccountNumber}</span>
          </div>
        </div>
        <Button
          variant="outline"
          className="border-gray-300 text-gray-700 hover:bg-gray-50 px-6 py-2 rounded-md font-medium"
          size="default"
          onClick={onUpdateClick}
        >
          Update Payment Method
        </Button>
      </CardContent>
    </Card>
  );
}; 